import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../api/api';
import { PreparationOperation } from '../../types';

interface PreparationOperationState {
  items: PreparationOperation[];
  loading: boolean;
}

const initialState: PreparationOperationState = { items: [], loading: false };

export const fetchPreparationOperations = createAsyncThunk('prepOp/fetchAll', async () => {
  const res = await api.get<PreparationOperation[]>('/preparationoperations');
  return res.data;
});

export const createPreparationOperation = createAsyncThunk('prepOp/create', async (data: any) => {
  const res = await api.post<PreparationOperation>('/preparationoperations', data);
  return res.data;
});

export const updatePreparationOperation = createAsyncThunk(
  'prepOp/update',
  async ({ id, data }: { id: number; data: any }) => {
    const res = await api.put<PreparationOperation>(`/preparationoperations/${id}`, data);
    return res.data;
  }
);

export const deletePreparationOperation = createAsyncThunk('prepOp/delete', async (id: number) => {
  await api.delete(`/preparationoperations/${id}`);
  return id;
});

const preparationOperationSlice = createSlice({
  name: 'prepOp',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreparationOperations.pending, (state) => { state.loading = true; })
      .addCase(fetchPreparationOperations.fulfilled, (state, action) => { state.loading = false; state.items = action.payload; })
      .addCase(fetchPreparationOperations.rejected, (state) => { state.loading = false; })
      .addCase(createPreparationOperation.fulfilled, (state, action) => { state.items.push(action.payload); })
      .addCase(updatePreparationOperation.fulfilled, (state, action) => {
        const idx = state.items.findIndex((i) => i.id === action.payload.id);
        if (idx >= 0) state.items[idx] = action.payload;
      })
      .addCase(deletePreparationOperation.fulfilled, (state, action) => {
        state.items = state.items.filter((i) => i.id !== action.payload);
      });
  },
});

export default preparationOperationSlice.reducer;
